import styled from 'styled-components'

export const ChartContainer = styled.div`
  height: ${props => props.verticalLegend ? '130px' : '100px'};
  clear: both;
`
